import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    alias: '首页',
    component: Home,
    meta: {
      title: '首页', keepAlive: true
    }
  },
  {
    path: '/login',
    name: 'login',
    alias: '登录',
    component: () => import('@/views/login/login.vue'),
    meta: {
      title: '登录', keepAlive: true
    }
  },
  {
    path: '/company',
    name: 'company',
    alias: '展商名录',
    component: () => import('@/views/company/company.vue'),
    meta: {
      title: '展商名录', keepAlive: true
    }
  },
  {
    path: '/companyList',
    name: 'companyList',
    alias: '展商列表',
    component: () => import('@/views/company/companyList.vue'),
    meta: {
      title: '展商列表', keepAlive: true
    }
  },
  {
    path: '/companyDetails',
    name: 'companyDetails',
    alias: '展商详情',
    component: () => import('@/views/company/companyDetails.vue'),
    meta: {
      title: '展商详情', keepAlive: false, parent: '/company'
    }
  },
  {
    path: '/product',
    name: 'product',
    alias: '产品名录',
    component: () => import('@/views/product/product.vue'),
    meta: {
      title: '产品名录', keepAlive: true
    }
  },
  {
    path: '/featuredProducts',
    name: 'featuredProducts',
    alias: '产品推荐',
    component: () => import('@/views/product/featuredProducts.vue'),
    meta: {
      title: '产品推荐', keepAlive: true
    }
  },
  {
    path: '/productDetails',
    name: 'productDetails',
    alias: '产品详情',
    component: () => import('@/views/product/productDetails.vue'),
    meta: {
      title: '产品详情', keepAlive: false, parent: '/product'
    }
  },
  {
    path: '/business',
    name: 'business',
    alias: '发布商机',
    component: () => import('@/views/business/business.vue'),
    meta: {
      title: '发布商机', keepAlive: true
    }
  },
  {
    path: '/businessDetail',
    name: 'businessDetail',
    alias: '商机详情',
    component: () => import('@/views/business/component/business_detail.vue'),
    meta: {
      title: '商机详情', keepAlive: false, parent: '/business'
    }
  },
  {
    path: '/webContent',
    name: 'webContent',
    alias: '二级页面',
    component: () => import('@/views/expo/webContent.vue'),
    meta: {
      title: '二级页面', keepAlive: true
    }
  },
  {
    path: '/review',
    name: 'review',
    alias: '历届回顾',
    component: () => import('@/views/expo/review.vue'),
    meta: {
      title: '历届回顾', keepAlive: true
    }
  },
  {
    path: '/reviewDetails',
    name: 'reviewDetails',
    alias: '历届回顾详情',
    component: () => import('@/views/expo/reviewDetails.vue'),
    meta: {
      title: '历届回顾详情', keepAlive: true, parent: '/review'
    }
  },
  {
    path: '/partner',
    name: 'partner',
    alias: '合作伙伴',
    component: () => import('@/views/expo/partner.vue'),
    meta: {
      title: '合作伙伴', keepAlive: true
    }
  },
  {
    path: '/contacts',
    name: 'contacts',
    alias: '联系我们',
    component: () => import('@/views/expo/contacts.vue'),
    meta: {
      title: '联系我们', keepAlive: true
    }
  },
  {
    path: '/news',
    name: 'news',
    alias: '新闻中心',
    component: () => import('@/views/expo/news.vue'),
    meta: {
      title: '新闻中心', keepAlive: true
    }
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    alias: '新闻详情',
    component: () => import('@/views/expo/newsDetails.vue'),
    meta: {
      title: '新闻详情', keepAlive: true
    }
  },
  {
    path: '/downloads',
    name: 'downloads',
    alias: '下载中心',
    component: () => import('@/views/expo/downloads.vue'),
    meta: {
      title: '下载中心', keepAlive: true
    }
  },
  {
    path: '/feedback',
    name: 'feedback',
    alias: '评价与反馈',
    component: () => import('@/views/mine/feedback.vue'),
    meta: {
      title: '评价与反馈', keepAlive: true
    }
  },
  {
    path: '/liveEvents',
    name: 'liveEvents',
    alias: '现场活动',
    component: () => import('@/views/active/liveEvents.vue'),
    meta: {
      title: '现场活动', keepAlive: false
    }
  },
  {
    path: '/activeList',
    name: 'activeList',
    alias: '活动',
    component: () => import('@/views/active/activeList.vue'),
    meta: {
      title: '活动', keepAlive: true, parent: '/liveEvents'
    }
  },
  {
    path: '/guest',
    name: 'guest',
    alias: '往届会议嘉宾',
    component: () => import('@/views/active/guest.vue'),
    meta: {
      title: '往届会议嘉宾', keepAlive: false
    }
  },
  {
    path: '/course',
    name: 'course',
    alias: '课程',
    component: () => import('@/views/active/course.vue'),
    meta: {
      title: '课程', keepAlive: true
    }
  },
  {
    path: '/courseDetails',
    name: 'courseDetails',
    alias: '会议详情',
    component: () => import('@/views/active/courseDetails.vue'),
    meta: {
      title: '会议详情', keepAlive: false, parent: '/liveEvents'
    }
  },
  {
    path: '/personal',
    name: 'personal',
    alias: '个人资料',
    component: () => import('@/views/personal/personal.vue'),
    meta: {
      title: '个人资料', keepAlive: true, isLogin: false,
    }
  },
  {
    path: '/mycollect',
    name: 'mycollect',
    alias: '我的收藏',
    component: () => import('@/views/mine/mycollect.vue'),
    meta: {
      title: '我的收藏', keepAlive: true, isLogin: true,
    }
  },
  {
    path: '/mybusiness',
    name: 'mybusiness',
    alias: '我的商机',
    component: () => import('@/views/mine/mybusiness.vue'),
    meta: {
      title: '我的商机', keepAlive: true, isLogin: true,
    }
  },
  {
    path: '/Japanese',
    name: 'Japanese',
    alias: '日文',
    component: () => import('@/views/Japanese.vue'),
    meta: {
      title: '日文', keepAlive: true, isLogin: false,
    }
  },
]
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
